import React from 'react';
import PropTypes from 'prop-types';

function SimpleTextListWidget(props) {
    if(!props?.title && !props?.text) return null;

    return (
        <div data-test-id="simpletext-wr" className={"widget widget-simpletextlist" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row text-sm-center mx-auto p-0">
                {props?.title ? <h3 data-test-id="simpletext-title" className={(props?.dark ? "text-white " : "") + "col-12 mb-3 mb-md-0"}>{props.title}</h3> : null}
                {props?.text ? <p data-test-id="simpletext-description" className={(props?.dark ? "text-white " : "") + "text-medium text-sm-small col-12"}>{props.text}</p> : null}
            </div>
        </div>
    )
}

SimpleTextListWidget.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    widget: PropTypes.string
}

export default SimpleTextListWidget;
